import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

const FormContainer = styled(Grid)(({ theme }) => ({
  maxWidth: '480px',
  padding: '0 10px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    margin: '0 auto',
  },
  marginTop: 0,
}));

const FormControl = styled('form')(({ theme }) => ({
  width: '480px',
  padding: '0 10px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
})) as typeof Container;

export { FormContainer, FormControl };
